<template>
  <footer class="bg-black pt-24 pb-12 px-6 border-t border-white/5">
    <div class="max-w-7xl mx-auto">
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
        <!-- Brand Column -->
        <div class="lg:col-span-2">
          <a href="#main" class="flex items-center gap-1 mb-6 group">
            <div class="flex items-center text-2xl font-black italic tracking-tighter">
              <span class="text-white uppercase">VIV</span>
              <span class="text-red-500 uppercase ml-1">STREAMS</span>
            </div>
          </a>
          <p class="text-gray-500 text-lg max-w-sm mb-8 font-medium leading-relaxed">
            The ultimate destination for slot enthusiasts. Watch live, win big, and join a community of winners.
          </p>
          <div class="text-gray-600 text-sm font-bold">
            © 2026 VIVSTREAMS. All rights reserved.
          </div>
        </div>

        <!-- Navigation -->
        <div>
          <h4 class="text-white font-black uppercase tracking-widest text-sm mb-8">Navigation</h4>
          <ul class="space-y-4">
            <li><a href="/" class="text-gray-500 hover:text-white font-bold transition-colors">Home</a></li>
            <li><a href="#promotions" class="text-gray-500 hover:text-white font-bold transition-colors">Promotions</a></li>
            <li><a href="#leaderboard" class="text-gray-500 hover:text-white font-bold transition-colors">Leaderboards</a></li>
            <li><a href="#socials" class="text-gray-500 hover:text-white font-bold transition-colors">Socials</a></li>
          </ul>
        </div>

        <!-- Quick Links -->
        <div>
          <h4 class="text-white font-black uppercase tracking-widest text-sm mb-8">Quick Links</h4>
          <ul class="space-y-4">
            <li>
              <a href="https://roobet.com/?lp=viv" target="_blank" class="text-gray-500 hover:text-white font-bold transition-colors flex items-center gap-1">
                Join Roobet Casino
                <svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M7 17l10-10M7 7h10v10"/></svg>
              </a>
            </li>
            <li>
              <a href="https://roobet.com/?lp=viv" target="_blank" class="text-gray-500 hover:text-white font-bold transition-colors flex items-center gap-1">
                Use Code: VIV
                <svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M7 17l10-10M7 7h10v10"/></svg>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <!-- Divider -->
      <div class="w-full h-px bg-white/5 mb-12"></div>

      <!-- Disclaimer -->
      <div class="max-w-5xl">
        <h5 class="text-gray-500 font-black text-xs uppercase mb-3 text-left">Disclaimer:</h5>
        <p class="text-gray-600 text-xs font-bold leading-relaxed text-left">
          VIVSTREAMS is a promotional website and does not offer real money gambling. All games shown are for entertainment purposes only. Users must be 18+ (or legal gambling age in your jurisdiction) to participate in any promotions. Please gamble responsibly. If you or someone you know has a gambling problem, seek help immediately.
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterElement"
};
</script>

<style scoped>
footer {
  font-family: 'Inter', sans-serif;
}
</style>
